import { IActionButtonCommonProps } from '../../typings/DocumentViewer/actionButtonCommonProps';
import DropdownMenuButton from '../dropdown/dropdownMenuButton';
import clsx from 'clsx';
import React, { forwardRef } from 'react';

export interface IActionButtonProps {
	label: string;
	handler: () => void;
	icon?: string;
	badge?: string;
	disabled?: boolean;
}

export interface IActionButtonModifiers {
	useContained?: boolean;
	useText?: boolean;
	useSmall?: boolean;
	useLarge?: boolean;
}

const ActionButton: React.ForwardRefExoticComponent<
	IActionButtonProps & Partial<IActionButtonCommonProps> & IActionButtonModifiers & React.HTMLProps<HTMLButtonElement>
> = forwardRef((props: IActionButtonProps & Partial<IActionButtonCommonProps> & IActionButtonModifiers, ref) => {
	if (props.isPrimary) {
		return (
			<div style={{ position: 'relative' }} className={props.className}>
				<button
					type="button"
					className={clsx('rup-btn', {
						'rup-btn--contained': props.useContained,
						'rup-btn--text': props.useText,
						'rup-btn--sm': props.useSmall,
						'rup-btn--lg': props.useLarge
					})}
					data-test-id={props.testId ?? 'btn'}
					data-controlled-by={props.controlledBy || 'self'}
					onClick={props.handler}
					disabled={props.disabled}
					ref={ref}
				>
					{props.icon && <span dangerouslySetInnerHTML={{ __html: props.icon }} />}
					{props.label}
				</button>
				{props.badge && (
					<span style={{ position: 'absolute', right: '-0.25rem', top: '-0.625rem' }} className="rup-badge">
						{props.badge}
					</span>
				)}
			</div>
		);
	} else {
		return (
			<DropdownMenuButton
				disabled={props.disabled}
				onClick={props.handler}
				testId={props.testId}
				controlledBy={props.controlledBy}
			>
				{props.label}
			</DropdownMenuButton>
		);
	}
});

ActionButton.displayName = 'ActionButton';

export default ActionButton;
